export type SecurityCheckStatus = 'VERIFIED' | 'PENDING' | 'MALICIOUS' | 'FAILED';

export type StatsResponse = {
    declarationsStatistic: {
        totalDeclarations: number;
        actionRequiredDeclarations: number;
    };
    jobsStatistic: {
        totalJobs: number;
        activeJobs: number;
        notAssignedJobs: number;
    };
    manifestsStatistic: {
        totalManifests: number;
        activeManifests: number;
    };
    invoicesStatistic: {
        totalInvoices: number;
        activeInvoices: number;
    };
    teamsStatistic: {
        totalTeams: number;
    };
};

export type StatisticsProps = {
    data: StatsResponse | null;
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<StatsResponse> | null;
};

export type ValidationWithSubErrors = {
    category: 'VALIDATION';
    message?: string;
    subErrors: {
        category: string;
        code: string;
        message: string;
        field: string;
    }[];
};

export enum EmailNotificationOverallStatuses {
    NOT_SENT = 'NOT_SENT',
    SENDING = 'SENDING',
    SENT = 'SENT',
    FAILED = 'FAILED',
}

export enum EmailNotificationProviderStatuses {
    SEND = 'SEND',
    DELIVERY = 'DELIVERY',
    BOUNCE = 'BOUNCE',
    COMPLAINT = 'COMPLAINT',
    REJECT = 'REJECT',
    OPEN = 'OPEN',
    CLICK = 'CLICK',
    RENDERING_FAILURE = 'RENDERING_FAILURE',
    DELIVERY_DELAY = 'DELIVERY_DELAY',
    SUBSCRIPTION = 'SUBSCRIPTION',
    UNKNOWN = 'UNKNOWN',
}

export type EmailNotificationData = {
    overallStatus: EmailNotificationOverallStatuses;
    overallProviderEventType?: EmailNotificationProviderStatuses;
    latestOverallProviderEventReason?: string;
    latestOverallProviderEventAt?: string;
    sendInProgress?: boolean;
    emailRequests?: EmailNotificationRequest[];
};

export type EmailNotificationRequest = {
    id: string;
    status: EmailNotificationOverallStatuses;
    providerEventType?: EmailNotificationProviderStatuses;
    latestProviderEventReason?: string;
    latestProviderEventAt?: string;
    toRecipients?: string[];
    ccRecipients?: string[];
    bccRecipients?: string[];
    senderId?: string;
    senderEmail?: string;
    subject?: string;
    attachments?: EmailNotificationAttachment[];
    errorMessage?: string;
    requestedAt?: string;
    providerEvents?: unknown[];
};

export type EmailNotificationAttachment = {
    type: string;
    fileName: string;
};

export type SupportedCurrencies = keyof typeof SUPPORTED_CURRENCIES_MAP;

export const SUPPORTED_CURRENCIES_MAP = {
    EUR: {
        code: 'EUR',
        label: 'Euro (€)',
        symbol: '€',
    },
    GBP: {
        code: 'GBP',
        label: 'Pound (£)',
        symbol: '£',
    },
} as const;
